import React, { useState } from 'react';
import { PlusIcon, PencilIcon, Trash2Icon } from 'lucide-react';
import { useContent, CategoryCard } from '../../ContentContext';
import { Field, TextArea, Modal, PrimaryButton, GhostButton } from './ui';
export function ContentManager() {
  const {
    content,
    updateContent,
    addCategoryCard,
    updateCategoryCard,
    deleteCategoryCard,
    resetAll
  } = useContent();
  const [editingCard, setEditingCard] = useState<CategoryCard | null>(null);
  const [isNewCard, setIsNewCard] = useState(false);
  const hero = content.hero;
  const setHero = (updates: Partial<typeof hero>) => updateContent({
    hero: {
      ...hero,
      ...updates
    }
  });
  const saveCard = () => {
    if (!editingCard) return;
    if (isNewCard) addCategoryCard(editingCard);else updateCategoryCard(editingCard.id, editingCard);
    setEditingCard(null);
  };
  return <div className="space-y-14" data-id="element-21" data-mp="jxe0bgm959wg">
      <div data-id="element-22" data-mp="jx4jaij6qd2w">
        <h1 className="font-display text-3xl font-medium text-gray-900" data-id="element-23" data-mp="jwl2j559tuqg">Startsida</h1>
        <p className="mt-2 text-sm text-gray-500" data-id="element-24" data-mp="xydy3yks5hrd">Styr rubriker, sökfält och kategorikort på förstasidan.</p>
      </div>

      {/* Hero */}
      <section className="rounded-3xl bg-white p-8 shadow-premium" data-id="element-25" data-mp="12wxm04ixp3md">
        <h2 className="font-display text-xl font-medium text-gray-900" data-id="element-26" data-mp="owwfa8fzn1yz">Hero & sökfält</h2>
        <div className="mt-6 grid gap-5 md:grid-cols-2" data-id="element-27" data-mp="tvzidnceqy4b">
          <Field label="Logotyp (URL)" value={hero.logo} onChange={v => setHero({
          logo: v
        })} hint="Lämna tomt för att dölja loggan." data-id="element-28" data-mp="tyvdz50s9apl" />
          <Field label="Etikett" value={hero.badge} onChange={v => setHero({
          badge: v
        })} data-id="element-29" data-mp="jz4o5gn63jvu" />
          <Field label="Bakgrundsbild (URL)" value={hero.backgroundImage} onChange={v => setHero({
          backgroundImage: v
        })} data-id="element-30" data-mp="6898nli5y4ja" />
          <div className="md:col-span-2" data-id="element-31" data-mp="a9l1dzwc35vp">
            <TextArea label="Rubrik" rows={2} value={hero.title} onChange={v => setHero({
            title: v
          })} hint="Radbrytning i fältet blir radbrytning på sidan." data-id="element-32" data-mp="3seo8tr9rvtza" />
          </div>
          <div className="md:col-span-2" data-id="element-33" data-mp="22z3sfwuncnz7">
            <TextArea label="Underrubrik" rows={2} value={hero.subtitle} onChange={v => setHero({
            subtitle: v
          })} data-id="element-34" data-mp="1y6u58okx220m" />
          </div>
          <Field label="Kategorier i sökfältet" value={hero.searchCategories.join(', ')} onChange={v => setHero({
          searchCategories: v.split(',').map(s => s.trim()).filter(Boolean)
        })} hint="Kommaseparerad lista." data-id="element-35" data-mp="1u6acrybafmkt" />
          <Field label="Snabbknappar under sökfältet" value={hero.quickLinks.join(', ')} onChange={v => setHero({
          quickLinks: v.split(',').map(s => s.trim()).filter(Boolean)
        })} hint="Kommaseparerad lista." data-id="element-36" data-mp="2hua16rl4n0w8" />
        </div>
      </section>

      {/* Category cards */}
      <section data-id="element-37" data-mp="11hctpsz95lr0">
        <div className="flex items-center justify-between" data-id="element-38" data-mp="11i4ncy9ah9en">
          <div data-id="element-39" data-mp="wh79uyz853jh">
            <h2 className="font-display text-xl font-medium text-gray-900" data-id="element-40" data-mp="wgfg7tp6tfvu">Kategorikort</h2>
            <p className="mt-1 text-sm text-gray-500" data-id="element-41" data-mp="mel5ktb4m273">Visas direkt under hero-sektionen.</p>
          </div>
          <PrimaryButton onClick={() => {
          setEditingCard({
            id: `cat-${Date.now()}`,
            title: '',
            subtitle: '',
            image: ''
          });
          setIsNewCard(true);
        }} data-id="element-42" data-mp="rdo8a73mvwbw">
            <span className="flex items-center gap-2" data-id="element-43" data-mp="113zfc2im6ln0">
              <PlusIcon className="h-4 w-4" data-id="element-44" data-mp="1549tw3kh2kdh" /> Nytt kort
            </span>
          </PrimaryButton>
        </div>

        <div className="mt-6" data-id="element-45" data-mp="1a2bg2xd72zt6">
          <Field label="Sektionsrubrik" value={content.categoriesHeading} onChange={v => updateContent({
          categoriesHeading: v
        })} data-id="element-46" data-mp="1a1jjpkbrwy1u" />
        </div>

        <div className="mt-6 grid gap-6 sm:grid-cols-2 xl:grid-cols-3" data-id="element-47" data-mp="1k0s8zzvp1ohv">
          {content.categoryCards.map(card => <div key={card.id} className="group relative h-56 overflow-hidden rounded-3xl bg-gray-100 shadow-premium" data-id="element-48" data-mp="3gvnd205gci6v">
              {card.image && <img src={card.image} alt={card.title} className="absolute inset-0 h-full w-full object-cover" data-id="element-49" data-mp="1g3v8cdpkcefu" />}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" data-id="element-50" data-mp="1b633yk7qezur" />
              <div className="absolute bottom-0 left-0 p-6" data-id="element-51" data-mp="1p405zw4yfygt">
                <h3 className="font-display text-2xl font-medium text-white" data-id="element-52" data-mp="1k5yk73g59l1n">{card.title}</h3>
                <p className="mt-1 text-xs text-white/80" data-id="element-53" data-mp="wgdqbpigd3dl">{card.subtitle}</p>
              </div>
              <div className="absolute right-4 top-4 flex gap-2" data-id="element-54" data-mp="we1dtrvgrl7x">
                <button onClick={() => {
              setEditingCard({
                ...card
              });
              setIsNewCard(false);
            }} aria-label={`Redigera ${card.title}`} className="flex h-9 w-9 items-center justify-center rounded-full bg-white/90 text-gray-900 backdrop-blur-md transition-colors hover:bg-white" data-id="element-55" data-mp="sgddg9b0508n">
                  <PencilIcon className="h-4 w-4" data-id="element-56" data-mp="8qje9a5yjiue" />
                </button>
                <button onClick={() => deleteCategoryCard(card.id)} aria-label={`Ta bort ${card.title}`} className="flex h-9 w-9 items-center justify-center rounded-full bg-white/90 text-gray-600 backdrop-blur-md transition-colors hover:bg-white hover:text-red-600" data-id="element-57" data-mp="2kdd4ysttdwdv">
                  <Trash2Icon className="h-4 w-4" data-id="element-58" data-mp="2ga71tu200lbm" />
                </button>
              </div>
            </div>)}
        </div>
      </section>

      {/* Partner section copy */}
      <section className="rounded-3xl bg-white p-8 shadow-premium" data-id="element-59" data-mp="382xyu6riae1x">
        <h2 className="font-display text-xl font-medium text-gray-900" data-id="element-60" data-mp="2u2ws4aok8cej">Partnersektion</h2>
        <div className="mt-6 grid gap-5 md:grid-cols-2" data-id="element-61" data-mp="2z1zv7pkzc8jv">
          <Field label="Rubrik" value={content.partnersHeading} onChange={v => updateContent({
          partnersHeading: v
        })} data-id="element-62" data-mp="2z4vqt79cul55" />
          <Field label="Underrubrik" value={content.partnersSubheading} onChange={v => updateContent({
          partnersSubheading: v
        })} data-id="element-63" data-mp="1nofa7am2dygp" />
        </div>
      </section>

      <section className="rounded-3xl border border-red-100 bg-red-50/50 p-8" data-id="element-64" data-mp="zjxtv2w8fbxy">
        <h2 className="font-display text-xl font-medium text-gray-900" data-id="element-65" data-mp="ut7ovqrpxb3s">Återställ plattformen</h2>
        <p className="mt-2 text-sm text-gray-600" data-id="element-66" data-mp="pumo9q8k0pet">
          Nollställer partners, sortiment, innehåll och förfrågningar till ursprungsläget.
        </p>
        <button onClick={() => {
        if (window.confirm('Är du säker? Alla ändringar försvinner.')) resetAll();
      }} className="mt-6 rounded-full border border-red-200 bg-white px-6 py-3 text-sm font-medium text-red-600 transition-colors hover:bg-red-600 hover:text-white" data-id="element-67" data-mp="kwuvku034z9k">
          Återställ allt
        </button>
      </section>

      {editingCard && <Modal title={isNewCard ? 'Nytt kategorikort' : `Redigera ${editingCard.title}`} onClose={() => setEditingCard(null)} footer={<>
              <GhostButton onClick={() => setEditingCard(null)} data-id="element-69" data-mp="28s9j6hoccrgq">Avbryt</GhostButton>
              <PrimaryButton onClick={saveCard} data-id="element-70" data-mp="2dr3yh9n3nxw3">Spara</PrimaryButton>
            </>} data-id="element-68" data-mp="2684izf2reqi0">
          <div className="grid gap-5" data-id="element-71" data-mp="2ijx4s1y7veaa">
            <Field label="Titel" value={editingCard.title} onChange={v => setEditingCard({
          ...editingCard,
          title: v
        })} hint="Matchar en produktkategori så filtreras utbudet automatiskt." data-id="element-72" data-mp="2ikyqd0cuzj69" />
            <Field label="Underrubrik" value={editingCard.subtitle} onChange={v => setEditingCard({
          ...editingCard,
          subtitle: v
        })} data-id="element-73" data-mp="1uucib92utyw9" />
            <Field label="Bild (URL)" value={editingCard.image} onChange={v => setEditingCard({
          ...editingCard,
          image: v
        })} data-id="element-74" data-mp="23u7xrq3g0g23" />
          </div>
        </Modal>}
    </div>;
}